var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_78_1327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7732 0H2.22682C0.99698 0 0 0.99698 0 2.22682V21.7732C0 23.003 0.99698 24 2.22682 24H21.7732C23.003 24 24 23.003 24 21.7732V2.22682C24 0.99698 23.003 0 21.7732 0Z",
    fill: "#EB0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1496 8.39181C18.8496 7.46863 17.8569 6.90953 16.9433 6.78135C13.6571 6.43226 10.3431 6.43226 7.05691 6.78135C6.14327 6.90953 5.14782 7.46317 4.85055 8.39181C4.38283 10.775 4.38283 13.2264 4.85055 15.6095C5.15055 16.5314 6.14327 17.0918 7.05691 17.22C10.3431 17.5691 13.6571 17.5691 16.9433 17.22C17.8569 17.0918 18.8524 16.5382 19.1496 15.6095C19.6174 13.2264 19.6174 10.775 19.1496 8.39181ZM10.2055 14.8745V9.12544L14.8855 12C13.3078 12.9695 11.7765 13.9091 10.2055 14.8745Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_78_1327"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.7b69c8735c8f17b2bd6cc26b6fa79202.svg";
export { ForwardRef as ReactComponent };